var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m.38 13 8.23 4.63c.23.13.52.13.75 0L17.59 13a.75.75 0 0 0 .39-.65v-7.7c0-.3-.16-.58-.44-.7l-.02-.01L9.3.34a.76.76 0 0 0-.6 0L.45 3.93H.43a.75.75 0 0 0-.43.7v7.7c0 .28.15.53.38.66Zm6.1-6.35 2.5 1.25 6.48-3.23-2.62-1.15-6.36 3.13ZM4.79 5.8 2.52 4.67l6.47-2.83 2.05.9L4.8 5.8Zm4.95 9.89V9.2l6.74-3.36v6.07L9.74 15.7Zm-1.5-6.5v6.5L1.5 11.9V5.85L8.24 9.2Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.4f39f61b8d6cbe92c36ea76ff216fe6b.svg";
export { ForwardRef as ReactComponent };